var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { InlineChildren, Text, Stack } from '@doordash/design-language';
import Button from '@doordash/component-button';
import CreateBudgetModal from './modals/create_budget_modal';
import { INITIAL_FETCH_STATUS } from '../../constants/fetch_status';
import * as React from 'react';
import { AdminPageSubpageContentContainer, SubpageContentHeaderSecondaryButtonContainer, } from '../AdminPage/AdminPageStyles';
import AdminBudgetsList from './admin_budgets_list';
import track from '../../utils/track';
export var AdminBudgets = function (_a) {
    var teamAccountId = _a.teamAccountId, _b = _a.budgets, budgets = _b === void 0 ? [] : _b, _c = _a.fetchStatus, fetchStatus = _c === void 0 ? INITIAL_FETCH_STATUS : _c;
    var _d = __read(React.useState(false), 2), isBudgetModalOpen = _d[0], setIsBudgetModalOpen = _d[1];
    React.useEffect(function () {
        track('workportal_view_budgets');
    }, []);
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "Meal Budgets"),
                React.createElement(SubpageContentHeaderSecondaryButtonContainer, null,
                    React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: function () {
                            setIsBudgetModalOpen(true);
                            track('workportal_click_add_budget');
                        } }, "Create Budget")),
                isBudgetModalOpen ? (React.createElement(CreateBudgetModal, { teamAccountId: teamAccountId, onClose: function () { return setIsBudgetModalOpen(false); } })) : null)),
        React.createElement(AdminBudgetsList, { teamAccountId: teamAccountId, budgets: budgets, fetchStatus: fetchStatus })));
};
export default AdminBudgets;
